﻿import { Component, OnInit} from '@angular/core';
import { RestService } from 'src/app/_services/rest.service';

@Component({ templateUrl: 'home.component.html' })
export class HomeComponent implements OnInit{

    mercadoPago: boolean = false;

    constructor(private restService: RestService) {

        this.restService.getParam('mercadolibre').subscribe(data => {
            this.mercadoPago = data.valor.toString().toUpperCase() === 'TRUE';
        });
    }

    ngOnInit() {
        this.restService.getParam('mercadolibre').subscribe(data => {
            this.mercadoPago = data.valor.toString().toUpperCase() === 'TRUE';
        });  
    }

}
